 import { call, select, takeEvery } from 'redux-saga/effects'
import { SETTINGS_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import { UPDATE_USER } from './user'
import { ACTIVE_LEASE_COUNT } from 'portal-modules/common/constants/types'
import { getSessionCookies, setSessionCookies } from 'portal-utils/session-cookies'

// action types
export const UPDATE_USER_SETTINGS = 'rp/userSettings/UPDATE_USER_SETTINGS'
export const CLEAR_USER_SETTINGS = 'rp/userSettings/CLEAR_USER_SETTINGS'

export const initialState = {
  hiddenFeedTypes: [],
  hiddenLeases: [],
  hiddenProperties: [],
  leaseId: 0,
  propertyId: 0,
}

const userKeys = ['leaseId', 'propertyId']

// reducer
export default function user(state = {}, { payload, type }) {
  switch (type) {
    case UPDATE_USER_SETTINGS:
      return { ...state, ...payload }
    case UPDATE_USER:
      if (payload.propertyId || payload.leaseId) {
        return {
          ...state,
          ...userKeys.reduce((obj, key) => {
            if (payload[key]) return { ...obj, [key]: payload[key] }
            return obj
          }, {}),
        }
      } else {
        return state
      }

    case CLEAR_USER_SETTINGS:
      return {}
    default:
      return state
  }
}

// action creators
export const updateUserSettings = payload => ({
  type: UPDATE_USER_SETTINGS,
  payload,
})

export const clearUserSettings = () => ({
  type: CLEAR_USER_SETTINGS,
})

// sagas
export function* syncUserSettings() {
  const { key, userSettings, properties } = yield select(
    ({ user, userSettings, properties }) => ({
      key: user.key,
      userSettings,
      properties,
    }),
  )
  userSettings['isBulkPayment'] =
    (userSettings['isBulkPayment'] &&
      properties &&
      properties[userSettings?.propertyId]?.leases?.length >=
        ACTIVE_LEASE_COUNT) ||
    false
  if (key) {
    const currentSettings = yield call(getSessionCookies, SETTINGS_STORAGE_KEY)
    yield call(setSessionCookies, SETTINGS_STORAGE_KEY, {
      ...(currentSettings || {}),
      [key]: userSettings,
    })
  }
}

export function* watchUserSettings() {
  yield takeEvery([UPDATE_USER_SETTINGS, UPDATE_USER], syncUserSettings)
}

export const sagas = [watchUserSettings]
